<template>
  <v-form ref="form">
    <v-layout wrap :style="{ margin: '-8px' }">
      <v-flex xs12 class="pa-2">
        <div class="caption">Sale type *</div>
        <v-radio-group
          v-model="form.type"
          row
          :rules="[rules.required]"
          class="ma-0"
          @change="handleTypeChange"
        >
          <v-radio value="success" label="Success" color="primary" />
          <v-radio value="unsuccess" label="Unsuccess" color="primary" />
          <v-radio value="other" label="Other" color="primary" />
        </v-radio-group>
      </v-flex>
      <v-flex v-if="form.type !== 'other'" xs12 class="pa-2">
        <v-layout wrap :style="{ margin: '-8px' }">
          <v-flex xs12 class="pa-2">
            <label for="eventName" class="caption">{{ $t('event') }} *</label>
            <v-select
              id="eventName"
              v-model="form.eventName"
              :items="eventNames"
              item-text="label"
              item-value="value"
              outline
              single-line
              @change="emit"
            />
          </v-flex>
          <v-flex xs12 sm6 class="pa-2">
            <label for="amount" class="caption">{{ $t('Amount') }} *</label>
            <v-text-field
              id="amount"
              v-model="form.amount"
              type="number"
              min="0"
              :rules="[rules.required]"
              outline
              single-line
              @change="emit"
            />
          </v-flex>
          <v-flex xs12 sm6 class="pa-2">
            <label for="currency" class="caption">{{ $t('monetary_unit') }} *</label>
            <v-autocomplete
              v-model="form.currency"
              :items="$store.state.currencies"
              outline
              single-line
              @change="emit"
            />
          </v-flex>
          <v-flex xs12 class="pa-2">
            <v-checkbox
              v-model="form.isSendToMeta"
              :label="$t('send_data_to_meta')"
              color="primary"
              hide-details
              :disabled="selectedBot.is_not_send_event_purchase_to_facebook"
              class="ma-0"
              @change="emit"
            />
            <div class="caption grey--text">*{{ $t('send_data_to_meta_requirement') }}</div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      form: {
        type: 'success',
        eventName: 'Purchase',
        amount: '',
        currency: 'THB',
        isSendToMeta: false,
        ...this.value
      },
      eventNames: [
        {
          label: 'View Content',
          value: 'ViewContent'
        },
        {
          label: 'Add to Cart',
          value: 'AddToCart'
        },
        {
          label: 'Purchase',
          value: 'Purchase'
        },
        {
          label: 'LeadSubmitted',
          value: 'LeadSubmitted'
        }
      ],
      rules: {
        required: (value) => !!value || this.$t('Required', { field: '' })
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    defaultCurrency() {
      try {
        return this.selectedBot.ticket_v3_config.default_currency || 'THB'
      } catch (error) {
        return 'THB'
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.form = {
        ...this.form,
        currency: this.defaultCurrency
      }
    },
    emit() {
      this.$emit('input', {
        ...this.form,
        ...(this.form.type === 'other' && {
          eventName: null,
          amount: null,
          currency: null
        })
      })
    },
    validate() {
      return this.$refs.form.validate()
    },
    handleTypeChange(value) {
      this.form.type = value
      this.form.isSendToMeta = ['success', 'unsuccess'].includes(value)
      this.emit()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/SaleForm.vue